<header class="bg-white position-absolute w-100 head-box" id="myHeader">
  <nav>
    <div class="search-bar-top products-search-top">
      <div class="close-icon d-block position-absolute">
        <a class="bg-transparent border-0 p-0 d-inline-block text-dark" href="javascript:void(0);"><i
          aria-hidden="true" class="flaticon-cancel"></i></a>
      </div>
      <form class="products-search">
        <div class="input-group">
          <input class="form-control" placeholder="Search entire store..." type="text">
          <div class="input-group-append">
            <button class="btn btn-secondary" type="button">
              <i aria-hidden="true" class="flaticon-search position-relative text-dark"></i>
            </button>
          </div>
        </div>
      </form>
    </div>
    <div class="container-fluid header_container">
      <div class="row align-items-center">
        <div class="col-lg-2 col-6">
          <div
            class="logo_search_group d-flex justify-content-between d-sm-flex justify-content-sm-between align-items-center">
            <div class="logo_wrap">
              <a class="d-inline-block" href=""><img style="height:10rem" alt="Logo" class="img-fluid"
                                                     src="/assets/images/logo.png"/></a>
            </div>
          </div>
        </div>
        <div class="col-md-8 right_menu_responsive py-5 py-lg-0">
          <div class="right_menu_close d-block d-lg-none position-absolute">
            <a class="bg-transparent border-0 p-0 d-inline-block text-dark" href="javascript:void(0);"><i
              aria-hidden="true" class="flaticon-cancel"></i></a>
          </div>
          <div class="right_menu text-left text-md-center">
            <ul class="pl-0 mb-0 menu_list_hover">
              <li class="d-inline-block mr-md-0 mb-md-3 mb-lg-0 px-xl-4 py-xl-2 px-lg-3 py-lg-1">
                <a (click)="closeMenu()" [routerLinkActiveOptions]="{ exact: true }"
                   class="d-inline-block open_sans bold_500 text-dark text-uppercase position-relative"
                   [routerLink]="['']"
                   [routerLinkActive]="'active'">Welcome</a>
              </li>
              <li class="d-inline-block mr-md-0 mb-md-3 mb-lg-0 px-xl-4 py-xl-2 px-lg-3 py-lg-1">
                <a (click)="closeMenu()" [routerLinkActiveOptions]="{ exact: true }"
                   class="d-inline-block open_sans bold_500 text-dark text-uppercase position-relative"
                   [routerLink]="['/news']"
                   [routerLinkActive]="'active'">News</a>
              </li>
              <li class="d-inline-block mb-md-3 mb-lg-0 px-xl-4 py-xl-2 px-lg-3 py-lg-1">
                <a (click)="closeMenu()" [routerLinkActiveOptions]="{ exact: true }"
                   class="d-inline-block open_sans bold_500 text-dark text-uppercase position-relative"
                   [routerLink]="['/app']"
                   [routerLinkActive]="'active'">App</a>
              </li>
              <li class="d-inline-block mb-md-3 mb-lg-0 px-xl-4 py-xl-2 px-lg-3 py-lg-1">
                <a (click)="closeMenu()" [routerLinkActiveOptions]="{ exact: true }"
                   class="d-inline-block open_sans bold_500 text-dark text-uppercase position-relative"
                   [routerLink]="['/sign-up']"
                   [routerLinkActive]="'active'">Sign Up</a>
              </li>
              <li class="d-inline-block mb-md-3 mb-lg-0 px-xl-4 py-xl-2 px-lg-3 py-lg-1">
                <a (click)="closeMenu()" [routerLinkActiveOptions]="{ exact: true }"
                   class="d-inline-block open_sans bold_500 text-dark text-uppercase position-relative"
                   [routerLink]="['/sign-in']"
                   [routerLinkActive]="'active'">Sign In</a>
              </li>
              <li class="d-inline-block mb-md-3 mb-lg-0 px-xl-4 py-xl-2 px-lg-3 py-lg-1">
                <a (click)="closeMenu()" [routerLinkActiveOptions]="{ exact: true }"
                   class="d-inline-block open_sans bold_500 text-dark text-uppercase position-relative"
                   [routerLink]="['/selling']"
                   [routerLinkActive]="'active'">Sell</a>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-lg-2 col-6 cart-icon-right">
          <div class="responsive_toggle d-flex align-content-center justify-content-end">
            <a class="search_scroll mr-3 mr-sm-4 d-inline-block sreach-icon" href="javascript:void(0);"><i
              aria-hidden="true" class="flaticon-search position-relative text-dark"></i></a>
            <a class="shop_cart_icon d-inline-block position-relative inner-cart-icon-right" href="javascript:void(0);">
              <i class="shop_bg d-inline-block"></i>
              <span
                class="bg_green position-absolute open_sans bold_700 font_10 text-white shop_count d-flex align-items-center justify-content-center">0</span>
            </a>
            <a
              class="bg-transparent responsive_side_toggle border-0 p-0 d-inline-block d-lg-none text-dark menu-icon-mobile"
              href="javascript:void(0);"><i
              aria-hidden="true" class="flaticon-menu position-relative"></i></a>
          </div>
        </div>
      </div>
    </div>
  </nav>
</header>
